<template>
  <div>
    <div id="myDiv" />
  </div>
</template>

<script>
import groupProductByProcessMixins from '../../mixins/groupProductByProcessMixins'
export default {
  mixins: [groupProductByProcessMixins],
  data () {
    return {
      img: 'image'
    }
  },
  mounted () {
    const data = []
    this.groupProductByProcess.forEach(group => {
      const newTrace = {
        x: group.processes.map(p => p.process.toLowerCase()),
        y: group.processes.map(p => p.temperature),
        xTitle: 'Temperatura Según Procesos',
        textposition: 'auto',
        text: group.processes.map(p => p.temperature.toString()),
        hoverinfo: 'none',
        name: group.product,
        type: 'bar'
      }
      data.push(newTrace)
    })

    const layout = {
      showlegend: true,
      barmode: 'group',
      autosize: true,
      title: 'Temperatura Según Procesos',
      xaxis: {
        title: {
          text: 'Procesos',
          font: {
            family: 'Courier New, monospace',
            size: 18,
            color: '#7f7f7f'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Temperaturas',
          font: {
            family: 'Courier New, monospace',
            size: 18,
            color: '#7f7f7f'
          }
        }
      }
    }
    const config = {
      displaylogo: false,
      scrollZoom: true,
      displayModeBar: true,
      editable: true,
      showLink: false
    }

    Plotly.newPlot('myDiv', data, layout, config).then(gd => { //eslint-disable-line
      Plotly.toImage(gd, { height: 700, width: 700 }) //eslint-disable-line
        .then((url) => {
          this.$emit('setImage', url)
        })
    })
  }
}
</script>
